<style scoped lang="less">
.modal-title {
    text-transform: uppercase;
}
</style>
<template>
    <div class="modal-content" ref="container">
        <div class="modal-header">
            <h2 class="modal-title">Workflow Manual Override Confirm</h2>
            <button type="button" class="close icon icon-close" aria-hidden="true" @click="close()" autofocus aria-label="Close" />
        </div>
        <div class="modal-body">
            <div describedby-text class="alert alert-danger">This action allows you to bypass safety controls. This is inherently unsafe, and may cause unexpected issues.</div>
            <div class="form-group" v-if="strictConfirm">
                <label for="confirmInput">To confirm, type "unsafe" in this box, and click Execute.</label>
                <input class="form-control" type="text" id="confirmInput" v-model="confirmValue" />
            </div>
        </div>
        <div class="modal-footer">
            <button id="returnBtn" class="btn btn-primary" @click="confirmFunc()" :disabled="!executable">Execute</button>
            <button id="cancelBtn" class="btn btn-outline-secondary" @click="close()">Cancel</button>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, computed, SetupContext } from "vue";
import { dialogSetup, DialogProps } from "@/lib/dialogMixin.3";
import { useMainStore } from "@/mainStore";
type Props = {
    returnFunction: () => void;
} & DialogProps;
export default defineComponent({
    props: ["returnFunction", "triggerElement"],
    setup(props: Props, { emit }: SetupContext) {
        const containerRef = ref<HTMLElement>(null!);
        dialogSetup(containerRef, props);

        const strictConfirm = ref(false);
        const confirmValue = ref(null as string | null);

        (async () => {
            strictConfirm.value = await useMainStore().isFeatureFlagActiveAsync("StrictWorkflowManualOverrideConfirm");
        })();

        const executable = computed(() => {
            return !strictConfirm.value || confirmValue.value == "unsafe";
        });

        const confirmFunc = async () => {
            if (!strictConfirm.value || confirmValue.value == "unsafe") {
                props.returnFunction();
                emit("close");
            } else {
                alert("Invalid confirm value");
            }
        };

        return {
            container: containerRef,
            executable,
            confirmFunc,
            confirmValue,
            strictConfirm,

            close: () => emit("close"),
        };
    },
});
</script>
